import React from 'react';

import FilterChips from '@totem/components/ui_components/reportSettings/filterChips';

import '../ticketing.css';

const TicketingListContainerFilterChips = () => {
  return <FilterChips />;
};

export default TicketingListContainerFilterChips;
